module.exports = __webpack_public_path__ + "static/media/eventsIcons.e9d2f18e.svg";